import React, { memo } from "react";
import { DeponieInfo } from "../../api";
import { Box, Stack, Typography } from "@mui/material";
import { useT } from "../../i18n";
import { formatEuroDe } from "../../utils/fomatters";

const WiegescheineSummenzeile = memo(
  ({ deponien }: { deponien: DeponieInfo[] }) => {
    const { t } = useT("eingangsrechnung");

    const sumByEinheit: Record<string, number> = deponien.reduce<
      Record<string, number>
    >((acc, deponie) => {
      const einheit: string = deponie.einheit || "Unbekannt";
      const menge: number = deponie.mengeGesamt || 0;
      acc[einheit] = (acc[einheit] || 0) + menge;
      return acc;
    }, {});

    const hasSums = Object.values(sumByEinheit).some((sum) => sum > 0);

    return (
      <Box
        sx={{
          ml: 2,
          mt: -0.5,
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <Typography variant="body2" sx={{ mr: 1 }}>
          {t("landfill-sum-title")}
        </Typography>
        <Stack
          direction="row"
          spacing={0.5}
          sx={{
            flexWrap: "wrap",
          }}
        >
          <Stack direction="row" spacing={1} sx={{ flexWrap: "wrap" }}>
            {deponien.length === 0 || !hasSums ? (
              <Box
                sx={{
                  fontSize: "0.75rem",
                  color: "text.secondary",
                  height: 20,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                -
              </Box>
            ) : (
              Object.entries(sumByEinheit).map(([einheit, sum]) => (
                <Box
                  key={einheit}
                  sx={{
                    backgroundColor: "transparent",
                    border: "1px solid transparent",
                    height: 20,
                    px: 1,
                    my: 0.2,
                    display: "flex",
                    alignItems: "center",
                    borderRadius: 1,
                    fontSize: "0.7rem",
                  }}
                >
                  {`${einheit}: ${formatEuroDe(sum)}`}
                </Box>
              ))
            )}
          </Stack>
        </Stack>
      </Box>
    );
  }
);

export default WiegescheineSummenzeile;
